import { render, staticRenderFns } from "./WorkgroupReportByEmployee.vue?vue&type=template&id=3b15a556"
import script from "./WorkgroupReportByEmployee.vue?vue&type=script&lang=js"
export * from "./WorkgroupReportByEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports